<template>
    <HeroSection />
    <AboutSection />
    <TalentDiagnosisSection />
    <ExperiencesSection />
</template>

<script>
import HeroSection from '../Home/HeroSection.vue';
import AboutSection from '../Home/AboutSection.vue';
import TalentDiagnosisSection from '../Home/TalentDiagnosisSection.vue';
import ExperiencesSection from './ExperiencesSection.vue';

export default {
  name: 'HomeIndex',
  components: {
    HeroSection,
    AboutSection,
    TalentDiagnosisSection,
    ExperiencesSection
  }
}
</script>